import { TabsContent } from "twyne-new.ui";

import { define, prop } from "@/components/builder/utils"

import BasePreview from "../base";

function StepPreview({ children, step, ...props }) {
  children = children || <Placeholder />

  return <BasePreview {...props}>
    <TabsContent value={`${step}`}>
      {children}
    </TabsContent>
  </BasePreview>
}

function Placeholder() {
  return <div className="m-1" style={{ height: '15vh', outline: '2px dashed var(--primary)' }}>
    <div className="w-100 h-100 bg-primary my-1" style={{ opacity: 0.2 }}>
    </div>
  </div>
}

export default define('step', StepPreview)
  .shared(prop.share('Step', 'form-step').props({ overrideType: 'step' }))
  // .palete('-- ', 'Step', 'Form')
  .property(prop.predefined.customClass())
  .property(prop.predefined.frame())
  .build()
